import { render, staticRenderFns } from "./commentDialog.vue?vue&type=template&id=d71f6d16"
import script from "./commentDialog.vue?vue&type=script&lang=js"
export * from "./commentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports